import React, {useEffect} from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import scrollToTop from "../components/hooks/ScrollToTop";
import './css/templates.css';

// Dmca Component

const Dmca = () => {
  const { t } = useTranslation();

    useEffect(() => {
        scrollToTop();
    }, []);

    useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
    },[])

  return (
    <div >
      <div className="page-wrapper">
        <Navbar />
      <section className="blog-area">
        <div className="hero-wrapper hero-7 space" id="hero">
          <div className="container-space">
            <div className="row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper">
              <div className="col-lg-12 col-md-6">
                <h3
                  className="text-center links-heading item-heading-font "
                  style={{ fontSize: "26px", color: "#ee7c2c" }}
                >
                  {t("dmca")}
                </h3>
                <div className="card-text item-content-font">
                  <p style={{ fontSize: "15px" }} className="mb-0-5">
                    <strong>
                      <u>
                        <span style={{ fontSize: "16px" }} className="mb-0-5">
                          {t("noticeAndProcedure")}
                        </span>
                      </u>
                    </strong>
                  </p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">{t("pursuantToTitle")}</p>
                  <p style={{ fontSize: "16px" }}className="mb-0-5">{t("noteTheFollowing")}</p>
                  <p
                    style={{
                      color: "rgb(231 52 52)",
                      // backgroundColor: "#f4cccc",
                      fontSize: "16px",
                    }}
                    className="mb-0-5"
                  >
                    {t("weCautionYouThat")}
                  </p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">{t("writtenNotification")}</p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">
                    NOA™
                    <br />
                    {t("attnLegal")}
                    <br />
                    {t("email")}
                    <Link to="mailto:support@joinnoa.io" className="orange-noa"> support@joinnoa.io</Link>
                  </p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">
                    {t("importantNoteInTheEvent")}
                  </p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">{t("underTitle17")}</p>
                  <ul style={{ fontSize: "16px", color: "#878680" }} className="mb-0-5">
                    <li>{t("physicalAndElectronic")}</li>
                    <li>{t("identificationOfTheCopyrighted")}</li>
                    <li>{t("identificationOfTheMaterial")}</li>
                    <li>{t("informationReasonably")}</li>
                    <li>{t("statementThatTheComplainingParty")}</li>
                    <li>{t("statementThatTheInformation")}</li>
                  </ul>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">
                    {t("uponReceiptOfNotification")}
                  </p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">
                    {t("eaconomyWillAlsoTake")}
                  </p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">{t("uponReceiptOfNotice")}</p>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">{t("toBeEffective")}</p>
                  <ul style={{ fontSize: "16px", color: "#878680" }} className="mb-0-5">
                    <li>{t("itMustBeAWritten")}</li>
                    <li>{t("itMustBeSent")}</li>
                    <li>
                      {t("itMustInclude")}
                      <ul>
                        <li>{t("aPhysicalOrElectronic")}</li>
                        <li>{t("identificationOfTheMaterialThat")}</li>
                        <li>{t("aStatementUnderPenalty")}</li>
                        <li>{t("theSubscribersName")}</li>
                      </ul>
                    </li>
                  </ul>
                  <p style={{ fontSize: "16px" }} className="mb-0-5">
                    {t("uponReceiptOfACounter")}
                  </p>
                  <ul style={{ fontSize: "16px", color: "#878680" }} className="mb-0-5">
                    <li>{t("promptlyProvideTheComplaining")}</li>
                    <li>{t("informTheComplainingParty")}</li>
                    <li>{t("replaceTheRemovedMaterial")}</li>
                  </ul>
                  <p
                    style={{
                      color: "rgb(231 52 52)",
                      // backgroundColor: "#f4cccc",
                      fontSize: "16px",
                    }}
                    className="mb-0-5"
                  >
                    {t("cautionPursuantToTitle17")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
    </div>
  );
};

export default Dmca;
